import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import { connect } from "react-redux";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Clearfix from "components/Clearfix/Clearfix.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardAvatar from "components/Card/CardAvatar.js";
import switchIntl from "configure/switchIntl.js";
import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import Snackbar from "components/Snackbar/Snackbar.js";

import loading from "assets/img/loading.gif";

import CryptoJS from "crypto-js";

import * as config from "configure/configServer.js";

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nochange: true,
      place: "tr",
      color: "success",
      message: "",
      file: null,
      imagePreviewUrl: loading,
      imgBase64: "",
      member_id: "",
      member_username: "",
      token: "",
      fnamestate: "",
      allinfo: {
        member_username: "",
        member_name: "",
        member_lname: "",
        member_email: "",
        member_status: "",
        member_tel: "",
        member_type: "",
        member_verify: "",
        member_profimg: loading,
        org_address: "",
        org_name: "",
        org_district: "",
        org_fax: "",
        org_floor: "",
        org_namebuilding: "",
        org_province: "",
        org_road: "",
        org_saletel: "",
        org_soi: "-",
        org_subdistrict: "",
        org_tel: "",
        org_website: "",
        p_value: "",
        tam_value: "",
      },
    };
    //this.requestToken = this.requestToken.bind(this);
  }
  fileInput = React.createRef();

  componentDidMount() {
    this.requestToken();
  }

  handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    let self = this;
    try {
      if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
        reader.onloadend = () => {
          this.setState({
            file: file,
            imagePreviewUrl: reader.result,
          });
          self.handleSubmit();
        };
        reader.readAsDataURL(file);
      } else {
        alert("Please select the image file");
      }
    } catch (err) {
      // console.log(err);
    }
  };

  showLoadingImage = () => {
    let allinfo = { ...this.state.allinfo };
    allinfo.member_profimg = loading;
    this.setState({ allinfo: allinfo });
  };

  handleSubmit = () => {
    // console.log("upload new image...");
    let self = this;
    self.showLoadingImage();
    let imgbase64_tmp = this.state.imagePreviewUrl;
    let imgbase64 = imgbase64_tmp.split(",");

    let info = {
      member_id: self.state.member_id,
      member_name: self.state.allinfo.member_name,
      member_lname: self.state.allinfo.member_lname,
      member_tel: self.state.allinfo.member_tel,
      member_profimg: imgbase64[1],
    };

    var request = new Request(config.API_updateprofile, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        token: self.state.token,
      }),
      body: JSON.stringify(info),
    });
    fetch(request)
      .then(function(response) {
        response.json().then(function(data) {
          switch (data.code) {
            case 200:
              // success
              self.getUserProfile(self.state.member_id);
              setTimeout(() => {
                self.showNotification("success", "อัพโหลดรูปภาพสำเร็จ");
              }, 1500);
              break;
            default:
              // failed
              self.showNotification(
                "warning",
                "ไม่สามารถอัพโหลดรูปได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง"
              );
              break;
          }
        });
      })
      .catch(function(err) {
        // console.log(err);
      });
  };

  showNotification(type, message) {
    this.setState({ open: true, color: type, message: message });
    setTimeout(
      function() {
        this.setState({ open: false });
      }.bind(this),
      6000
    );
  }

  setOrgInfo = (companyinfo) => {
    this.setState({ company: companyinfo });
  };

  getUserProfile = (member_id) => {
    let self = this;
    var request = new Request(config.API_profile, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        token: self.state.token,
      }),
      body: JSON.stringify({
        member_id: member_id,
      }),
    });
    fetch(request)
      .then(function(response) {
        response.json().then(function(data) {
          // console.log(data);
          let info = data.data;
          switch (data.code) {
            case 200:
              // success
              // self.setState({ allinfo: info });
              self.setState(
                {
                  allinfo: info,
                },
                () => {
                  let profile_path = info.member_profimg;
                  let imgpath = config.requestUrl + profile_path;
                  let allinfo = { ...self.state.allinfo };
                  allinfo.member_profimg = imgpath;
                  // console.log(imgpath);
                  self.setState({ allinfo: allinfo });
                }
              );

              break;
            default:
              // failed

              break;
          }
        });
      })
      .catch(function(err) {
        // console.log(err);
      });
  };

  requestToken = () => {
    var request = new Request(config.API_gen_secretkey, {
      method: "POST",
      headers: new Headers({ "Content-Type": "application/json" }),
    });
    fetch(request)
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.code === 200) {
          const key = responseJson.data;
          const keyutf = CryptoJS.enc.Utf8.parse(key);
          const iv = CryptoJS.enc.Base64.parse(key);

          var aesStr = localStorage.getItem("sessionP");
          const dec = CryptoJS.AES.decrypt(
            { ciphertext: CryptoJS.enc.Base64.parse(aesStr) },
            keyutf,
            {
              iv: iv,
            }
          );
          const decStr = CryptoJS.enc.Utf8.stringify(dec);
          const jsonDec = JSON.parse(decStr);
          this.setState({
            token: jsonDec.token,
            member_id: jsonDec.member_id,
            member_username: jsonDec.member_username,
          });
          this.getUserProfile(jsonDec.member_id);
        }
      })
      .catch((err) => {});
  };

  handleClick = () => {
    this.fileInput.current.click();
  };

  change(event, stateName, type) {
    let allinfo = this.state.allinfo;
    allinfo[stateName] = event.target.value;
    this.setState({ allinfo: allinfo });
    switch (type) {
      case "tel":
        if (this.verifyPhone(event.target.value)) {
          this.setState({ [stateName + "_state"]: "success" });
        } else {
          this.setState({ [stateName + "_state"]: "error" });
        }
        break;
      case "text":
        if (this.verifyName(event.target.value)) {
          this.setState({ [stateName + "_state"]: "success" });
        } else {
          this.setState({ [stateName + "_state"]: "error" });
        }
        break;
      default:
        break;
    }

    //enable update button
    this.setState({ nochange: false });
  }

  verifyPhone = (value) => {
    //var phoneRex = /^0[0-9/-]+$/;
    var phoneRex = /^[0-9, /-]+$/;

    if (phoneRex.test(value)) {
      return true;
    }
    return false;
  };

  verifyName(value) {
    var nameRex = /^[A-Za-zก-๙]+$/;
    if (nameRex.test(value)) {
      return true;
    }
    return false;
  }

  verifyAll = () => {
    if (
      this.state.member_name_state === "error" ||
      this.state.member_lname_state === "error" ||
      this.state.member_tel_state === "error"
    ) {
      this.showNotification("warning", "กรุณาตรวจสอบข้อมูลก่อนทำการบันทึก");
    } else {
      this.updateProfile();
    }
  };

  updateProfile = () => {
    let self = this;
    let info = {
      member_id: self.state.member_id,
      member_name: self.state.allinfo.member_name,
      member_lname: self.state.allinfo.member_lname,
      member_tel: self.state.allinfo.member_tel,
      member_profimg: "",
    };

    var request = new Request(config.API_updateprofile, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        token: self.state.token,
      }),
      body: JSON.stringify(info),
    });
    fetch(request)
      .then(function(response) {
        response.json().then(function(data) {
          switch (data.code) {
            case 200:
              //success
              self.showNotification("success", "เปลี่ยนแปลงข้อมูลเรียบร้อย");
              self.getUserProfile(self.state.member_id);

              //clear checking state
              self.setState({
                member_name_state: "",
                member_lname_state: "",
                member_tel_state: "",
                nochange: true,
              });
              break;
            default:
              //failed
              self.showNotification(
                "warning",
                "ไม่สามารถเปลี่ยนแปลงข้อมูลได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง"
              );
              break;
          }
        });
      })
      .catch(function(err) {
        // console.log(err);
      });
  };

  render() {
    const { classes, toggleLng } = this.props;

    return (
      <div>
        <GridContainer>
          <Snackbar
            place={this.state.place}
            color={this.state.color}
            message={this.state.message}
            open={this.state.open}
            closeNotification={() => this.setState({ open: false })}
            close
          />
          <GridItem xs={12} sm={12} md={4}>
            <Card profile lg={12}>
              <CardAvatar profile>
                <a
                  href={this.state.allinfo.member_profimg}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={this.state.allinfo.member_profimg} alt="..." />
                </a>
              </CardAvatar>
              <CardBody>
                <Button color="rose">
                  {switchIntl(toggleLng).userprofile.upload_new_profile}
                  <input
                    type="file"
                    onChange={this.handleImageChange}
                    ref={this.fileInput}
                    accept="image/x-png,image/gif,image/jpeg"
                    style={{
                      fontSize: "100px",
                      position: "absolute",
                      left: 0,
                      top: 0,
                      opacity: 0,
                    }}
                  />
                </Button>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <PermIdentity />
                </CardIcon>
                <h4>{switchIntl(toggleLng).userprofile.header}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.username}
                      id="member_username"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.member_username,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.firstname}
                      success={this.state.member_name_state === "success"}
                      error={this.state.member_name_state === "error"}
                      id="first-name"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) =>
                          this.change(event, "member_name", "text"),
                        value: this.state.allinfo.member_name,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.lastname}
                      success={this.state.member_lname_state === "success"}
                      error={this.state.member_lname_state === "error"}
                      id="last-name"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) =>
                          this.change(event, "member_lname", "text"),
                        value: this.state.allinfo.member_lname,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.phone}
                      success={this.state.member_tel_state === "success"}
                      error={this.state.member_tel_state === "error"}
                      id="member_tel"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) =>
                          this.change(event, "member_tel", "tel"),
                        value: this.state.allinfo.member_tel,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.email}
                      id="member_email"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.allinfo.member_email,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.company}
                      id="org_name"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.allinfo.org_name,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.address}
                      id="org_address"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.allinfo.org_address,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.buildingname}
                      id="org_namebuilding"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.allinfo.org_namebuilding,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.floor}
                      id="org_floor"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.allinfo.org_floor,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.soi}
                      id="org_soi"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.allinfo.org_soi,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.road}
                      id="org_road"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.allinfo.org_road,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.prov}
                      id="org_province"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.allinfo.org_province,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.dis}
                      id="org_district"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.allinfo.org_district,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.subdis}
                      id="org_address"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.allinfo.org_subdistrict,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.tel}
                      id="org_tel"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.allinfo.org_tel,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.fax}
                      id="org_fax"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.allinfo.org_fax,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={switchIntl(toggleLng).userprofile.web}
                      id="org_website"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.allinfo.org_website,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <Button
                  color="rose"
                  disabled={this.state.nochange}
                  className={classes.updateProfileButton}
                  onClick={() => this.verifyAll()}
                >
                  {switchIntl(toggleLng).userprofile.submit}
                </Button>
                <Clearfix />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

UserProfile.propTypes = {
  classes: PropTypes.object,
};
const mapStateToProps = (state) => ({
  ...state,
});

export default connect(mapStateToProps)(
  withStyles(userProfileStyles)(UserProfile)
);
